import { showController } from '../show-controller/index';
import { handlePageToThs } from '../utils/utils';
const win: any = window;
const isUse = showController('hitNewStock');
const isShare = !win.F10Utils.getBroker() && win.F10Utils.getUrlParams('fromshare');
/**
 * 当前交易账户已申购成功的新股信息
 */
export const getUserBuyStockList = (success: Function) => {
    if (isUse) {
        win.callNativeHandler('hasApplyStockInfo', {},
            (data: any) => {
                const res = data;
                success && success(res);
            }
        );
        return
    }
    success && success({
        data: []
    });
    return ;
}

/**
 * 当前交易账户预约新股状态
 */
 export const getOrderNewStockState = (success: Function) => {
    win.callNativeHandler('orderNewStockState', {},
        (data: any) => {
            const res = data;
            success && success(data);
        }
    );
}

/**
 * 当前交易账户预约新股状态
 */
 export const getJumpToOrderNewStock = (success: Function) => {
    // 分享页面调用下载同花顺方法
    if (isShare) {
        handlePageToThs();
        return;
    }
    // 存在开户sdk，执行对应弹窗方法
    if (win.checkPermission) {
        // 当前环境变量
        const env = win.getParam("sdkDebug") ? 'test' : 'release'
        win.checkPermission(null, () => {
            //　存在登录交易记录，执行原有方法
            win.callNativeHandler('jumpToOrderNewStock', {},
                (data: any) => {
                    const res = data;
                    success && success(data)
                }
            );
        }, env)
    } else {
        win.callNativeHandler('jumpToOrderNewStock', {},
            (data: any) => {
                const res = data;
                success && success(data)
            }
        );
    }

}

/**
 * 在交易中，页面底部按钮样式
 * 返回参数：
 * {
 *   action: "getBottomBtnStyle",
 *   param:｛
 * 　　"btnStyle": "0", //0 不显示 1 "一键预约" 2 "查看预约"
 *   ｝
 * }
 */
export const getBottomBtnStyle = (success: Function) => {
    win.callNativeHandler('JSXGSGCalendarEvent', {
        action:'getBottomBtnStyle',
    },
        (data: any) => {
            let res = data;
            if(res.param){
                res = res.param;
            }
            success && success(res)
        }
    );
}

/**
 * 在交易中，页面底部点击所触发的客户端行为
 * 入参：
 * type: 1：一键预约  2：查看预约
 * 
 * 返回参数：
 * {
 *   action: "clickBottomBtn",
 *   param:｛
 * 　　// 状态码信息...
 *   ｝
 * }
 */
 export const clickBottomBtn = (type: number, success?: Function) => {
    win.callNativeHandler('JSXGSGCalendarEvent', {
        action:'clickBottomBtn',
        param:{ btnStyle: type }
    },
        (data: any) => {
            success && success(data)
        }
    );
}

/**
 * 在交易中，获取用户中签数据
 * 返回参数：
 * {
 *   action: "getZhongQianData",
 *   param:｛
 *     "errorCode": 0,
 * 　　"data":[{stockCode,stockName}]
 *   ｝
 * }
 */
 export const getZhongQianData = (success: Function) => {
    win.callNativeHandler('JSXGSGCalendarEvent', {
        action:'getZhongQianData',
    },
        (data: any) => {
            success && success(data.param.data)
        }
    );
}
